import React from 'react';
import { useParams } from 'react-router-dom';
import CreateComplianceRecord from './CreateComplianceRecord';

const ViewComplianceRecord = () => {
  const { id } = useParams();

  return <CreateComplianceRecord viewMode={true} complianceId={id} />;
};

export default ViewComplianceRecord;

